import { render } from "./MappaSpostamenti.vue?vue&type=template&id=f3441366&scoped=true"
import script from "./MappaSpostamenti.vue?vue&type=script&lang=js"
export * from "./MappaSpostamenti.vue?vue&type=script&lang=js"

import "./MappaSpostamenti.vue?vue&type=style&index=0&id=f3441366&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3441366"]])

export default __exports__